import axios from 'axios';
import axiosRetry from 'axios-retry';
const { isNetworkOrIdempotentRequestError } = axiosRetry
const retryable400 = [401, 403];
const isRetryable400Error = (e) => {
	if (e.response) return retryable400.includes(e.response.status)
	return true
}

const retry_config = {
	retries: 2,
	retryCondition: (e) => (isNetworkOrIdempotentRequestError(e) || isRetryable400Error(e)),
	retryDelay: (retryCount, error) => {
		if (error.response?.status === 504) return 5000; 
		return retryCount * 1000;
	}
}

axiosRetry(axios, retry_config)

export const getAPIErrorType = (err) => {
	const status = err.response ? err.response.status : "";
	if (status === 204) return "EMPTY"
	if (status === 401 || status === 403) return "ERROR_LOGOUT"
	if (status === 404) return "ERROR_NOTFOUND"
	if (status === 500 || status === 502 || status === 503) return "ERROR_RETRY"
	return "ERROR_UNKNOWN"
}

	export default axios;